export const FormTemplates = {
  index: () => ({ url: '/administration/form_templates' }),
};
